







































































































import Vue from 'vue'
import { SpiderRepository } from '@/core/api/spiders'
import CompareCard from '@/components/compare-card.vue'
import DatePicker from '@/components/date-picker.vue'

const repository = new SpiderRepository()

export default Vue.extend({
  components: {
    CompareCard,
    DatePicker,
  },
  props: {
    spiderId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    filter: {
      dateStart: null as any,
      dateEnd: null as any,
    },
    search: '',
    expanded: [],
    dialog: false,
    data: null,
    item: null,
    items: [],
    spiders: [],
    resultsCount: 0,
    samplesCount: 0,
    loading: false,
    pageSize: 20,
    page: 1,
    headers: [
      {
        text: 'Дата',
        value: 'publish_date',
        width: '150px',
      },
      {
        text: 'URL',
        value: 'url',
        width: '200px',
      },
      {
        text: 'Заголовок',
        align: 'start',
        value: 'title',
      },
      {
        text: 'Проблемы',
        align: 'center',
        value: 'problems',
      },
      {
        text: 'Схожесть',
        align: 'center',
        value: 'similarity',
      },
    ],
    colorMap: {
      'E': 'red darken-2',
      'W': 'orange darken-2',
      'I': 'green darken-2',
    },
  }),
  mounted() {
    this.filter = {
      dateStart: this.$moment(),
      dateEnd: this.$moment(),
    }
    this.fetch()
  },
  methods: {
    async fetch() {
      if (this.spiderId == null) {
        return
      }

      this.loading = true
      try {
        const { data } = await repository.getAnalyzerResults(
          this.spiderId,
          this.filter.dateStart.startOf('day').toDate(),
          this.filter.dateEnd.endOf('day').toDate(),
        )
        this.items = data.items
        this.spiders = data.spiders
        this.resultsCount = data.results_count
        this.samplesCount = data.samples_count
      } catch (err) {
        this.$toastError.fire()
      }
      this.loading = false
    },
    getProblemColor(problems: { code: string }[]) {
      for (const [prefix, color] of Object.entries(this.colorMap)) {
        if (problems.some(x => x.code.startsWith(prefix))) {
          return color
        }
      }
    },
    onItemClick(item) {
      this.item = item
      this.dialog = true
    },
    onDownloadExcelFileClick() {
      repository.getAnalyzerExcelFile(
        this.spiderId,
        this.filter.dateStart.startOf('day').toDate(),
        this.filter.dateEnd.endOf('day').toDate(),
      )
    },
  },
})
